export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package_group": {
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "pg_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "package_quantity": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("quantity")), " ", _interpolate(_named("name")), " de ", _interpolate(_named("gross_weight")), " Kg"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor(a)"])},
            "thermo_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termoregistro"])},
            "grouped_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de armado"])},
            "exporter_process_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marca"])},
            "exporter_process_crop_category_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoría"])},
            "exporter_process_crop_category_id_abbreviation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cat. "])},
            "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comentario"])},
            "packing_house_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso de empaque"])},
            "agro_exporter_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso de exportación"])},
            "total_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total de paquetes"])},
            "packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques"])},
            "ready_to_container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
          }
        }
      },
      "en": {
        "model": {
          "package_group": {
            "pg_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "package_quantity": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("quantity")), " ", _interpolate(_named("name")), " ", _interpolate(_named("gross_weight")), " Kg"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
            "exporter_process_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand"])},
            "exporter_process_crop_category_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
            "exporter_process_crop_category_id_abbreviation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cat. "])},
            "thermo_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thermocode"])},
            "grouped_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assambled date"])},
            "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comment"])},
            "packing_house_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packing house process"])},
            "agro_exporter_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro exporter process"])},
            "total_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total packages"])}
          }
        }
      }
    }
  })
}